import { render, staticRenderFns } from "./RedefinirSenha.vue?vue&type=template&id=fc28087c&scoped=true"
import script from "./RedefinirSenha.vue?vue&type=script&lang=ts"
export * from "./RedefinirSenha.vue?vue&type=script&lang=ts"
import style0 from "./RedefinirSenha.vue?vue&type=style&index=0&id=fc28087c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc28087c",
  null
  
)

export default component.exports